import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppServiceService } from 'src/app/api/app-service.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-order-summery',
  templateUrl: './order-summery.page.html',
  styleUrls: ['./order-summery.page.scss'],
})
export class OrderSummeryPage implements OnInit {
  @Input() webUniqueId: string = '';

  checkOrder: boolean = true;
  unique: any = '';
  orderInfo: any;
  essenRate: number = 0;
  lifebernRate: number = 0;
  reviewText: string = '';
  // This array will decide how many starts display for ratings
  stars = [1, 2, 3, 4, 5];
  reviewErrors: any = null;
  // to check wether user has left a review or not
  hasLeftaReview: boolean = false;
  // the message receive after saving review
  reviewSuccess: string = '';

  orderDeliveryDate: any;
  orderDeliveryTime: any;

  totalTaxAmount = 0;

  constructor(public appService: AppServiceService, private route: ActivatedRoute, private datePipe: DatePipe, private router: Router) {

    setTimeout(() => {
      this.appService.appObject.isLoading = true;
    }, 10);

    this.route.params.subscribe((param) => {
      this.unique = param.unique;
    });

    // when open order summary page from web app
    setTimeout(() => {
      if (this.appService.isWebVersion && this.webUniqueId) this.unique = this.webUniqueId;
    }, 10);
  }

  ngOnInit() {
  }

  // ionViewDidEnter() {

  //   setTimeout(() => {
  //     this.getOrderInfo();
  //   }, 500);
  //   setInterval(() => {
  //     if (this.checkOrder) {
  //       this.getOrderInfo();
  //     }
  //   }, 2000);


  // }
  ngAfterViewInit() {
    setTimeout(() => {
      this.getOrderInfo();
    }, 500);
    setInterval(() => {
      if (this.checkOrder) {
        this.getOrderInfo();
      }
    }, 2000);
  }

  ionViewWillEnter() {
  }

  ionViewWillLeave() {
    // console.log('leaveng');
    this.checkOrder = false;
  }

  ngOnDestroy() {
    this.checkOrder = false;
  }

  async getOrderInfo() {
    this.appService.getOrderInfo(this.unique).then(data => {
      if (data.status) {
        this.orderInfo = data.data;

        if (this.orderInfo.delivery_time_resturent) {
          var dateTimeArr = this.orderInfo.delivery_time_resturent.split(" ");
          this.orderDeliveryDate = dateTimeArr[0];
          this.orderDeliveryTime = dateTimeArr[1];
        }

        if (this.orderInfo.review) {
          this.hasLeftaReview = true;
          this.essenRate = this.orderInfo.order_review_stars;
          this.lifebernRate = this.orderInfo.order_review_delivery_type_stars;
          this.reviewText = this.orderInfo.review;
        }

        if (this.orderInfo.status == 'rejected' || this.orderInfo.status == 'completed') {
          this.checkOrder = false;
        }

        
        // get total tax amount to display instead of tax type
        this.totalTaxAmount = ((this.orderInfo.total_tax_inclusive ? this.orderInfo.total_tax_inclusive : 0) + (this.orderInfo.total_tax_exclusive ? this.orderInfo.total_tax_exclusive : 0));
      }
      this.appService.appObject.isLoading = false;
    }, error => {
      this.appService.appObject.isLoading = false;
    });
  }

  /**
   * Save user review
   */
  saveUserReview() {
    if (this.orderInfo.payment_id) {
      this.reviewErrors = null;
      this.appService.appObject.isLoading = true;
      let reviewData = {
        payment_id: this.orderInfo.payment_id,
        review_text: this.reviewText,
        order_review_stars: this.essenRate,
        order_review_delivery_type_stars: this.lifebernRate
      };
      // console.log('Review Data :  ', reviewData);
      this.appService.insertUserReview(reviewData).then((response: any) => {
        // console.log('Review Response : ', response);

        if (response.status) {
          this.reviewSuccess = response.msg;
          this.hasLeftaReview = true;
          // set a time out to clear review success message
          setTimeout(() => {
            this.reviewSuccess = '';
          }, 5000);
        } else {
          this.reviewErrors = response.msg;
        }

        this.appService.appObject.isLoading = false;
      }).catch((error) => {
        console.log('error (leaving user review) : ', error);
        this.appService.appObject.isLoading = false;
      });
    }
  }

  /**
   * When user tap on order again in order summary
   */
  orderAgain() {
    this.router.navigate([this.appService.isWebVersion ? ('/menu/' + this.orderInfo.restaurantDetails.slug) : ('/restaurant/' + this.orderInfo.restaurantDetails.slug)])
    // if this is web version, then close the modal dialog
    if (this.appService.isWebVersion) this.appService.modalDismiss();
  }

}
